import axiosClient from '../utils/axiosClient';
import config from '../config';

const getBonusDraw = async () => {
  const applicationId = config.APPLICATION_ID;

  try {
    const response = await axiosClient.get(
      `${config.API_BASE_URL}/bonusDraw/getActive`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export { getBonusDraw };
